import { BaseObject } from "../core/BaseObject";
import { TariffEmployeeCategory } from "./TariffEmployeeCategory";

export class Tariff extends BaseObject {
    tariffId: number;
    tariffType: number;
    tariffTypeString: string;

    tariffEmployeeCategories: TariffEmployeeCategory[] = [];
}